module.exports = __webpack_public_path__ + "static/HaydenLambson 640x640-72e111b223ffa4ffef65fe097375ceb7.jpg";